import { forwardRef, useCallback, useState } from "react";
import styles from "./index.module.less";

export default forwardRef(function PinVideo({ fullWidth, isLarge, pin }, ref) {
  const [canVideoPlay, setCanVideoPlay] = useState(false);
  const [progress, setProgress] = useState(0);

  const onTimeUpdate = useCallback((evt) => {
    const progress = (
      (evt.currentTarget.currentTime / evt.currentTarget.duration) *
      100
    ).toFixed(1);
    setProgress(progress);
  }, []);

  const width = isLarge ? 480 : 240;

  return (
    <>
      <video
        ref={ref}
        src={pin.file_material?.extra?.video_mask}
        muted
        autoPlay
        loop
        preload="metadata"
        style={{ display: canVideoPlay ? "block" : "none" }}
        width={Math.min(fullWidth ? 1200 : width, pin.file?.width)}
        height={Math.round(
          (pin.file?.height / pin.file?.width) *
            Math.min(fullWidth ? 1200 : width, pin.file?.width)
        )}
        onCanPlayThrough={() => setCanVideoPlay(true)}
        onTimeUpdate={onTimeUpdate}
      />
      <div className={styles.progress} style={{ width: `${progress}%` }}></div>
    </>
  );
});
